export const HOME = '/navegarcomseguranca';
